<button type="button" class="pill trigger" [class.has-leading-matsymbol]="matSymbol()?.symbol"
  [class.icon-only]="iconOnly()" [disabled]="isDisabled()"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin" (click)="toggle()">
  @if (matSymbol(); as sym) {
    <i class="material-symbols-outlined" [class.filled]="sym.filled" [style.color]="sym.color">{{ sym.symbol }}</i>
  }
  @if (!iconOnly()) {
    <span class="text" [class.placeholder]="selectedLabel() === null">
      {{ selectedLabel() ?? placeholder() }}
    </span>
    <i class="material-icons-outlined caret">
      {{ open() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </i>
  }
</button>

<ng-template cdkConnectedOverlay appOverlayPanel matchTriggerWidth
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="open()"
  [panelPositions]="positions()"
  (panelClose)="open.set(false)">
  <ul class="select-menu">
    @for (option of options(); track option.value) {
      <li [class.checked]="isChecked(option)" (click)="select(option)">
        <i class="material-icons-outlined check">check</i>
        <span class="title">{{ option.label }}</span>
      </li>
    } @empty {
      <li class="empty" i18n="@@dropdown.nothing_to_select">Nothing to select</li>
    }
  </ul>
</ng-template>
